<template>
    <CustomCreateDialog dialogTitle="اطلاعات فروش درس" dialogId="lesson-analytic-modal" okTitle="بستن" :ok-only="true"
        @close="okLessonDialogModal" @ok="okLessonDialogModal">
        <BCol cols="12">
            <CustomTable v-if="[tableItems]" :pageNumber="1" :count="10" :totalCount="totalCount"
            @changePage="changePage"
                :tableColumns="tableColumns" :tableItems="tableItems">

            </CustomTable>
        </BCol>
    </CustomCreateDialog>
</template>
<script>
export default {
    emits: ["closeLessonAnalyticModal"],
    props: {
        lessonData: {
            type: Object,
        },
    },
    // mounted(){
    //     this.getOrderLessonsDetails(this.lessonData)
    // },
    watch: {
        lessonData: {
            handler(val) {
                this.lessonDetailFilter = {...val}
                this.getOrderLessonsDetails(val)
            },
            deep: true
        },

    },
    data() {
        return {
            tableItems: null,
            totalCount: null,
            lessonDetailFilter:null,
            tableColumns: [
                {
                    key: "userId",
                    label: "شناسه",
                },
                {
                    key: "userName",
                    label: "نام کاربر",
                },
                {
                    key: "allPrice",
                    label: "قیمت کل سفارش",
                    formatter: (value) =>
                        `${value ? Intl.NumberFormat("en-US").format(value) : "0"} تومان`,
                },
                {
                    key: "allPriceAfterDiscunt",
                    label: "قیمت کل بعد از تخفیف",
                    formatter: (value) =>
                        `${value ? Intl.NumberFormat("en-US").format(value) : "0"} تومان`,
                },
                {
                    key: "orderId",
                    label: "شماره سفارش",
                },
                {
                    key: "paydBy",
                    label: "خرید توسط",
                    formatter: (value) => {
                        switch (value) {
                            case 1: return "کیف پول";
                            case 2: return "درگاه بانکی";
                            case 3: return "ادمین";
                            default: return "نامشخص";
                        }
                    }
                },
                {
                    key: "createDate",
                    label: "تاریخ خرید",
                    formatter: (val) => new Date(val).toLocaleDateString("fa-IR")
                },

            ],
        };
    },

    methods: {
        changePage(pageNumber) {
      this.lessonDetailFilter.pageNumber = pageNumber;
      this.getOrderLessonsDetails(this.lessonDetailFilter);
    },
        okLessonDialogModal() {
            this.$emit('closeLessonAnalyticModal')

        },
        async getOrderLessonsDetails(orderData) {
            try {
                this.isLoading = true;
                const _this = this;
                const getOrdersLessonsDetails = new GetOrderLessonsDetails(
                    _this
                );
                getOrdersLessonsDetails.setRequestParamDataObj(
                    orderData
                );
                await getOrdersLessonsDetails.fetch((response) => {
                    if (response.isSuccess) {
                        _this.tableItems = response.data.data
                        _this.totalCount = response.data.total
                    }
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
    },
    components: {
        CustomCreateDialog,
        IndependentLessonPicker,
        BCol,
        CustomTable,
    },
};
import { AddLessonToUserArray } from "@/libs/Api/Order";
import IndependentLessonPicker from "./IndependentLessonPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BCol } from "bootstrap-vue";
import { GetOrderLessons, GetOrderLessonsDetails } from "@/libs/Api/Lesson";
</script>
